import angular from 'angular';
import ngCookies from 'angular-cookies';
import constants from 'app/constants';
import { default as orgDataService } from 'app/services/data/org.data.service';

const library = require('@safe-systems/ss-ui-components');

const {
  alerts,
  loaderService,
  ssDialogService,
} = library;
import controller from './clear-notifications-dialog.controller';
import template from './clear-notifications-dialog.html';

class dialogService {
  getOptions($event, { alertList }) {
    return {
      controller,
      controllerAs: 'clearNotificationsDialogVM',
      locals: {
       alertList,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.global.applicationNotifications.clearNotificationsDialog', [
  loaderService,
  alerts,
  ssDialogService,
  orgDataService, 
])
  .service('clearNotificationsDialog', dialogService)
  .name;

console.log('app.components.global.applicationNotifications.clearNotificationsDialog created');